import React from "react";
import { Box, useTheme } from "@mui/material";
import { Plus } from "lucide-react";

interface EmptyAddCardCstProps {
  addLabel: string;
  onAdd: () => void;
  minHeight?: string | number;
  disabled?: boolean;
}

const EmptyAddCardCst: React.FC<EmptyAddCardCstProps> = ({
  addLabel,
  onAdd,
  minHeight = "120px",
  disabled = false,
}) => {
  const theme = useTheme();

  return (
    <Box
      onClick={disabled ? undefined : onAdd}
      aria-disabled={disabled}
      sx={{
        minHeight,
        opacity: disabled ? 0.5 : 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "12px",
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.card || "#2A2A2A",
        cursor: disabled ? "not-allowed" : "pointer",
        transition: "border-color 120ms ease",
        "&:hover": disabled
          ? {}
          : {
              borderColor: theme.palette.primary.main,
            },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          color: theme.palette.primary.main,
          fontSize: "14px",
          fontWeight: 600,
        }}
      >
        {addLabel}
        <Plus size={16} />
      </Box>
    </Box>
  );
};

export default EmptyAddCardCst;
